<template>
  <img 
      v-if="useImg"
      :src="imgUrl"
      :title="title"
      :class="['icon', square ? 'square' : '']"
      @error="imgError = true"
      @click="clickFn">
  <div 
      v-else
      :class="['icon', square ? 'square' : '']"
      :title="title"
      @click="clickFn">
    {{ label }}
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    type: String, //user, work
    obj: {
      type: [Object, String],
      default: null
    },
    isImg: {
      type: Boolean,
      default: false
    },
    defaultImg: {
      type: String,
      default: ''
    },
    customTitle: {
      type: String,
      default: ''
    },
    square: {
      type: Boolean,
      default: false
    },
    clickFn: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      imgError: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      offline: state => state.offline.isOffline
    }),
    useImg() {
      return this.isImg && !this.offline && this.imgUrl && !this.imgError;
    },
    imgUrl() {
      switch(this.type) {
        case 'work':
          return this.$anm22.getObjIcon(this.obj, this.defaultImg);
          break;
        case 'user':
          return this.$anm22.getObjIcon(this.obj, this.defaultImg);
          break;
      }
    },
    label() {
      if(this.obj) {
        switch(this.type) {
          case 'work':
            return this.obj.name ? this.obj.name.substring(0,1) : 'Work';
            break;
          case 'user':
            return this.obj.name.substring(0,1) + this.obj.surname.substring(0,1);
            break;
        }
      }
    },
    title() {
      if(this.obj) {
        if(this.customTitle) {
          return this.customTitle;
        } else {
          switch(this.type) {
            case 'work':
              return this.obj.name;
              break;
            case 'user':
              return this.obj.name + ' ' + this.obj.surname;
              break;
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.icon {
  width: 100%;
  height: 100%;
  padding: 0;
}
img.icon {
  background-color: #fff;
  border-radius: 50%;
  &.square {
    border-radius: 0;
  }
}
div.icon {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content:center;
  color: #fff;
  background-color: #00af87;
  border-radius: 50%;
  user-select: none;
  font-size: 14px;
  // padding-top: calc((100% - 16px) / 2);
  &.square {
    border-radius: 0;
  }
}
</style>